import { render } from "./Index.vue?vue&type=template&id=4efcb5db"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=4efcb5db&lang=css"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/superAdmin/ecole/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4efcb5db"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4efcb5db', __exports__)) {
    console.log('reload')
    api.reload('4efcb5db', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=4efcb5db", () => {
    console.log('re-render')
    api.rerender('4efcb5db', render)
  })

}


export default __exports__